import Swiper from 'swiper/bundle';

var boletimMercado = document.querySelector(".slide-boletim-container")

if (boletimMercado) {
	new Swiper(boletimMercado, {
		slidesPerView: "auto",
		spaceBetween: 32,
		centeredSlides: true,
		grabCursor: 'true',

		navigation: {
			nextEl: boletimMercado.querySelector(".swiper-button-next"),
			prevEl: boletimMercado.querySelector(".swiper-button-prev"),
		},
	});
}
